import { RoleFunction } from '@eagle/common';
import { Card, CardContent, Divider, Stack } from '@ethings/ui-toolkit';
import { TabContext } from '@mui/lab';
import { Box } from '@mui/material';
import { FC, type JSX } from 'react';
import { useAuthenticated } from '../../auth';
import { MediaTabs } from './media-data.types';
import { NoPermission } from './no-permission';

interface Props {
  'data-testid'?: string;
  displayOnCard: boolean;
  mediaOverlay: JSX.Element;
  selectedTab: MediaTabs;
  tabPanels: JSX.Element;
  tabs: JSX.Element;
  viewButton: JSX.Element;
}

export const MediaCardLayoutMobile: FC<Props> = ({
  displayOnCard,
  mediaOverlay,
  selectedTab,
  tabPanels,
  tabs,
  viewButton,
  ...props
}) => {
  const { userInfo } = useAuthenticated();
  const hasMediaPermissions = userInfo.hasRoleFunction(RoleFunction.MEDIA_VIEWER);
  const hideCardProperties = !displayOnCard ? { boxShadow: 'none' } : {};

  if (!hasMediaPermissions) return <NoPermission sx={hideCardProperties} />;

  return (
    <Card data-testid={props['data-testid']} style={hideCardProperties}>
      <CardContent data-testid="card-content" style={{ padding: 0 }}>
        <TabContext value={selectedTab}>
          <Stack>
            {tabs}
            <Divider />
          </Stack>
          {tabPanels}
          <Box sx={{ display: 'flex', justifyContent: 'center', pt: 1 }}>
            {viewButton}
          </Box>
          {mediaOverlay}
        </TabContext>
      </CardContent>
    </Card>
  );
};
